import React, { useCallback } from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';
import { useGetProductGroupsForOffer } from '@occc-app/dataAccessLayer/productGroup/queries';

import { ConfigureForm } from './ConfigureForm';
import { transformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';

import { ChallengeConfigureFormInitialValues, ChallengeConfigureFormValues } from '../../types';

export const ChallengeConfigureFormContainer: React.FC<FormContainerProps> = (props) => {
  const { offer } = props;
  const productGroups = useGetProductGroupsForOffer(offer);
  const transformOfferToInitialValuesWithProductGroups = useCallback(
    (currentOffer: Parameters<typeof transformOfferToInitialValues>[0]) =>
      transformOfferToInitialValues(currentOffer, productGroups),
    [productGroups],
  );

  const configureProps = useGetConfigureFormProps<
    ChallengeConfigureFormValues,
    ChallengeConfigureFormInitialValues
  >(props, transformOfferToInitialValuesWithProductGroups, getConfigureFormOperations);

  return <ConfigureForm {...configureProps} />;
};
